import api from "./api";

// Progress-aware multipart upload of a hero video.
// Returns the server response { url, slot, branding }.
// NOTE: no manual Content-Type — axios sets the multipart boundary itself.
export async function adminUploadBrandingVideo(slot, file, onProgress) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post(`/branding/video/${slot}`, form, {
    onUploadProgress: (e) => {
      if (onProgress && e.total) {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    },
  });
  return data;
}
